import * as Yup from 'yup';

export const personalValidation = Yup.object().shape({
  firstName: Yup.string().required('Ce champ est requis').default(''),
  lastName: Yup.string().required('Ce champ est requis').default(''),
  address: Yup.string().required('Ce champ est requis').default(''),
  postcode: Yup.string().required('Ce champ est requis').default(''),
  city: Yup.string().required('Ce champ est requis').default(''),
});
